import { useCallback, useRef } from 'react'
import { useSelector } from '../../../../hooks/useSelector'
import usePlayerActions from '../../hooks/usePlayerActions'
import { truncateCash } from '@prometheus/utils'
import classNames from 'classnames'
import { Card, Stack, Table, Typography } from '@prometheus/components'
import { useDispatch } from 'react-redux'
import { pushError } from '@/reducers/game/game'

export const PlayerStarbaseLoans = () => {
  const loans = useSelector(s => s.game.sheet?.starbase_loans) || []
  const { onUpgradePlanet } = usePlayerActions()
  const is_map = useSelector(s => s.game.galaxy_display)
  const cacheRef = useRef<any>({})
  const dispatch = useDispatch()

  const onRowClicked = useCallback(async (index: number) => {
    if (cacheRef.current[index]) {
      return
    }
    cacheRef.current[index] = true;

    try {
      await onUpgradePlanet(index, 'starbase-refund')
    } catch (e) {
      dispatch(pushError({ type: 'error', message: (e as any).message }))
    } finally {
      delete cacheRef.current[index]
    }
  }, [onUpgradePlanet])

  if (!loans.length) {
    return null
  }

  return (
    <Card transparent padding="sm" style={{ position: 'relative', zIndex: 1, borderTopRightRadius: '0', borderBottomRightRadius: '0', borderRight: 'none' }} className={classNames({ is_map })}>
      <Stack>
        <Typography retro variant="h4" color="primary" uppercase>Starbase Loans</Typography>
        <Table
          columns={[{
            key: 'amount',
            label: 'Amount'
          }, {
            key: 'cost',
            label: 'Cost',
          }, {
            key: 'rate',
            label: 'Rate',
          }]}
          striped
          onRowClicked={onRowClicked}
          data={loans.map((loan) => ({
            amount: truncateCash(loan.amount),
            cost: truncateCash(loan.cost),
            rate: `${(loan.cost / loan.amount * 100).toFixed(1)}%`
          }))}
        />
      </Stack>
    </Card>
  )
}
